export const SESSION_ITEM_ROW_CLASS =
  "flex items-start gap-1 border border-transparent pl-1 pr-3 py-2 rounded-lg";

// Goes on a div inside each row's motion wrapper, never on the wrapper itself
// (see sessionRowPopMotion).
export const SESSION_ITEM_ROW_WRAP_CLASS = "pb-0.5";

export const SESSION_ITEM_INDICATOR_GUTTER_CLASS =
  "flex w-4 shrink-0 items-center justify-center py-[7px]";

// With SessionSidebar's SESSION_CHILDREN_CLASS pl-1.5, puts nested titles 20px
// past the rail (ProjectDropGap and "Show more" pad to match).
export const NESTED_SESSION_ITEM_INDICATOR_GUTTER_CLASS =
  "flex h-4 w-3.5 shrink-0 items-center justify-center";

export const SESSION_SECTION_HEADER_BOX_CLASS =
  "w-full flex items-center justify-between px-3 pb-1 border border-transparent";

// PrStateFilter's size-5 icons stand 2px taller than the section title. The
// My Sessions header keeps that height without them (a sidebar too narrow for
// the filter) and its skeleton reserves it, so the rows below never move.
export const MY_SESSIONS_HEADER_MIN_HEIGHT_CLASS = "min-h-5";

// Pairs with the group/session-sidebar class on the sidebar panel. The
// skeleton panel has no such group, so there it stays hidden like a live
// sidebar the pointer isn't over.
export const REVEAL_ON_SIDEBAR_HOVER_CLASS =
  "opacity-0 group-hover/session-sidebar:opacity-100 group-has-[:focus-visible]/session-sidebar:opacity-100 [@media(hover:none)]:opacity-100";

// The panel's color as a content-attached background lets Chrome composite
// the scroller at 1x DPR without giving up LCD text. Uncomposited, every row's
// clips are re-layerized with the whole page on each keystroke and stream
// frame.
export const SESSION_LIST_SCROLLER_CLASS =
  "h-full overflow-y-auto overflow-x-hidden bg-sidebar [background-attachment:local] [scrollbar-gutter:stable]";

/** Whether the session list's bottom fade is hidden: nothing below to reveal. */
export function isSessionListScrolledToBottom(el: HTMLElement) {
  return (
    el.scrollHeight <= el.clientHeight ||
    el.scrollTop + el.clientHeight >= el.scrollHeight - 4
  );
}

export const SESSION_FOOTER_CLASS =
  "flex-shrink-0 flex items-center justify-end px-4 pt-3 pb-2";

export const SESSION_FOOTER_LABEL_CLASS =
  "text-xs font-normal leading-4 text-neutral-500 dark:text-neutral-400";

// Rail under the parent's chevron.
// Chromium rounds a half-pixel `left` up to the next CSS pixel, drawing the
// rail 0.5px right of the chevron's center; a transform lands on the 2x device
// pixel instead. At 1x no crisp 1px line can center there, so it stays put.
export const SESSION_CHILDREN_RAIL_CLASS =
  "pointer-events-none absolute bottom-2 left-0 top-1 w-px bg-[var(--color-border)] [@media(min-resolution:2dppx)]:translate-x-[0.5px]";
